import React, { useCallback } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import SignaturePad from '../../SignaturePad'
import { Guest } from '../../types'
import {
	RoomChargeActionIcon, RoomChargeConfirmButton, RoomChargeSecondaryButton, RoomChargeStepHint, RoomChargeStepHintIcon,
} from '../index.styled'
import { SignActions, SignIntro, SignIntroAccent } from './index.styled'

type Props = {
	guest: Guest | null
	roomNumber: string
	formattedTotal: string
	signature: string | null
	isPosting: boolean
	canSkipSignature: boolean
	errorMessage: string | null
	onSignatureChange: (dataUrl: string | null) => void
	onSubmit: (skipSignature: boolean) => void
}

const RoomChargeSignStep = React.memo(({
	guest, roomNumber, formattedTotal, signature, isPosting, canSkipSignature, errorMessage, onSignatureChange, onSubmit,
}: Props) => {
	const { t } = useTranslation()

	const handleSubmitWithSignature = useCallback(() => onSubmit(false), [onSubmit])
	const handleSubmitWithoutSignature = useCallback(() => onSubmit(true), [onSubmit])

	return (
		<>
			<SignIntro>
				<Trans i18nKey={guest ? 'RoomCharge.sign.intro' : 'RoomCharge.sign.introWithoutGuest'}
							 values={{ name: guest?.fullName, amount: formattedTotal, room: roomNumber }}
							 components={{ bold: <SignIntroAccent /> }} />
			</SignIntro>

			<SignaturePad onChange={onSignatureChange} />

			{errorMessage &&
				<RoomChargeStepHint>
					<RoomChargeStepHintIcon icon="alert-triangle" />
					{errorMessage}
				</RoomChargeStepHint>}

			<SignActions>
				<RoomChargeConfirmButton type="button"
																 disabled={!signature || isPosting}
																 onClick={handleSubmitWithSignature}>
					<RoomChargeActionIcon icon={isPosting ? 'loader' : 'check-circle'} className={isPosting ? 'spinning' : ''} />
					{t('RoomCharge.sign.submit')}
				</RoomChargeConfirmButton>
				{canSkipSignature &&
					<RoomChargeSecondaryButton type="button" disabled={isPosting} onClick={handleSubmitWithoutSignature}>
						{t('RoomCharge.sign.withoutSignature')}
					</RoomChargeSecondaryButton>}
			</SignActions>
		</>
	)
})

RoomChargeSignStep.displayName = 'RoomChargeSignStep'
export default RoomChargeSignStep
